import { Query } from "../bus/Query";
import type { IterationCostRollupDto } from "../contracts/IterationCostContracts";

export class GetIterationCostQuery extends Query<ReadonlyArray<IterationCostRollupDto>> {
  constructor(public readonly runId: string) {
    super();
  }
}
